import { RecommendationGender, Recommendation } from '@shared/types/recommendation';
import { useRecommendationGender } from './use-recommendation-gender';
import { useFetchRecommendations } from './use-fetch-recommendations';

export const useRecommendations = (): Recommendation[] => {
    const recomendationsMale = useFetchRecommendations(RecommendationGender.MALE);
    const recomendationsFemale = useFetchRecommendations(RecommendationGender.FEMALE);
    const gender = useRecommendationGender();

    if (gender === RecommendationGender.MALE && recomendationsMale.length) {
        return recomendationsMale;
    }

    return recomendationsFemale || [];
};
